export default {
  title: 'Migrationsstatus: {type}',
  confirmReset: {
    header: 'Migrationsstatus von {count} {type} zurücksetzen?',
    message: 'Alle {type} werden erneut ab den ersten verfügbaren Daten in PT9800 migriert.',
  },
};
